<template><div v-if="entry" v-html="html" /></template>

<script setup lang="ts">
import type { Entry } from 'contentful';
import { resolveEntry } from '~/utils/resolveEntry';
import type { EntryWithLinkData, ICustomHtml } from '~/lib/ContentfulService';
import 'iframe-resizer/js/iframeResizer.contentWindow';

const route = useRoute();
const id = String(route.params.id);
const locale = useLocale();

const { data } = useFetch<{ entry: EntryWithLinkData<Entry<unknown>> }>(
  `/api/contentful/byId/${id}`,
  {
    ...DEFAULT_FETCH_OPTIONS,
    query: {
      locale: locale.value
    }
  }
);

const entry = computed(() => {
  if (data.value?.entry) {
    return resolveEntry<ICustomHtml>(data.value.entry as any, true);
  }
});
const html = computed(() => entry.value?.fields?.html ?? '');

definePageMeta({
  layout: 'raw'
});
</script>
